<template>
	<ul class="list-group note" v-if="type=='hasol'">
		<li class="list-group-item">
			<p class="info">您今天共有{{data.length}}条待办事宜</p>
		</li>
		<li class="list-group-item" v-for="(list,index) in data">
			<span class="pull-right">{{list.time}}</span>
			<span class="label" :class="list.state|setState">{{index+1}}</span> {{list.title}}
		</li>
	</ul>
	<ul class="list-group note" v-else>
		<li class="list-group-item" v-for="(list,index) in data">
			<span class="pull-right">{{list.time}}</span>
			<span class="label" :class="list.state|setState">{{index+1}}</span> {{list.title}}
		</li>
	</ul>
</template>
<script>
	export default {
		props: {
			type:String,
			data: Array,
		},
		methods: {

		},
		computed: {

		},
		filters: {
			setState(a) {
				return a ? "label-" + a : "label-default"
			}
		}
	}
</script>
<style lang="less">
	@import (reference) "../../../assets/lib/css.less";
	.list-group.note {
		li {
			.unbd;
			.textoh;
		}
		li+li {
			.bdrt;
		}
		.label {
			.mgr(@mpb/3);
			&-default {
				background-color: @cc2;
			}
		}
		.info {
			.mgb(0)
		}
	}
</style>


// WEBPACK FOOTER //
// note.vue?dc227f76